import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../global/LoadingSpinner';
import { useState } from 'react';
import LanguagesSelector from './LanguagesSelector';
import { useCheckCodeProduct, useGetVendor } from '../../hooks/public/Vendors';
import ImageWithFallback from '../global/ImageWithFallback';
import ReviewFromProfile from './ReviewFromProfile';
import { useLocation } from 'react-router-dom';
import ReviewFromProduct from './ReviewFromProduct';

export default function ReviewFromCode() {
  const { t } = useTranslation();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const qCode = searchParams.get('code');

  const [profileId, setProfileId] = useState(false);
  const [productId, setProductId] = useState(false);
  const [showInput, setShowInput] = useState(true);
  const [code, setCode] = useState("");


  const { data, isLoading, isError } = useGetVendor();
  const { mutate: CheckCode, data: CodeData, isLoading: codeIsLoading } = useCheckCodeProduct();

  useEffect(() => {
    if (qCode && showInput) {
      setShowInput(false);
      setCode(qCode);
      CheckCode({ data: { code: qCode }, message: t("review.error.wrCode") });
    }


    if (CodeData?.code?.length > 0) {
      const newProfileId = CodeData?.company[0];
      const newProductId = CodeData?.product[0];
      setProfileId(newProfileId);
      setProductId(newProductId);
      setShowInput(false);
      const newUrl = `${location.pathname}?code=${CodeData?.code[0]}`;
      window.history.pushState({}, '', newUrl);
    }
  }, [CheckCode, CodeData, location.pathname, qCode, t]);

  const handleChange = (e) => {
    setCode(e.target.value);
  }

  const handleSubmit = () => {
    CheckCode({ data: { code: code }, message: t("review.error.wrCode") });
  }

  if (isLoading || codeIsLoading) return <LoadingSpinner />
  if (isError) return 'An error has occurred: ' + isError.message;
  //return <pre>{JSON.stringify(data ,null,2)}</pre>;

  return (<>
    {showInput ? (<div id="invoiceInvite">
      <LanguagesSelector lang={data.languages} />
      <div className="invoiceInviteWrap">
        <div className="invoiceInviteContent">
          <div className="invoiceInviteLogoWrap">
            <ImageWithFallback src={data.logo_url} alt={data.logo_url} style={{ margin: "0px auto" }} />
          </div>
          <div className="invoiceInviteTitle">
            <h2>{t("review.code.h1")}</h2>
          </div>
          <div className="invoiceInviteText">
            <p><strong>{t("review.code.h2")}</strong></p>
          </div>
          <div className="invoiceInviteForm">
            <input className="form-control" autoFocus type="text" onChange={handleChange} />
            <div className="invoiceInviteFormSubmit">
              <button type="submit" onClick={handleSubmit} className="btn btn-default btn-save" title={t("review.code.con") + " »"}>{t("review.code.con")} »</button>
            </div>
          </div>
        </div>
      </div>
    </div>) : (<>

      {profileId && <ReviewFromProfile id={profileId} code={code} />}
      {productId && <ReviewFromProduct id={productId} code={code} />}

    </>)
    }
  </>)
}
